import '../../Assets/Styles/home.css';
import '../../Assets/Styles/blog.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {useNavigate,useParams} from 'react-router-dom';

import { Helmet } from 'react-helmet';

import { Skeleton } from '@mui/material';

import jwtDecode from 'jwt-decode';

// Load Actions
import * as AppActions from '../../Store/Actions/App'

// Load Componentes
import HeaderView from '../../Components/Layout/Header';
import FaqView from '../../Components/Partner/Faq';
import BlogHighlightCarousel from '../../Components/BlogHighlightCarousel';

// Set assets
import fallbackImage from '../../Assets/Images/blogImage3.png';
import webdoorNews1 from '../../Assets/Images/webdoorNews1.png';


import {
    getSlugWithId
} from '../../Components/Utils';


import {
    WhatsappShareButton,
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    TelegramShareButton,
    ThreadsShareButton,
    WhatsappIcon,
    LinkedinIcon,
    TwitterIcon,
    TelegramIcon,
    ThreadsIcon,
    EmailIcon,
    FacebookIcon
  } from 'react-share'; 


const BlogView = (props) => {
    
// Set var from props
const {
    setDialog,
    setLoginStatus,
    loginStatus,
    currentCompanyStatus,
    activationStatus,
    setActivationStatus,
} = props;


const { slugId } = useParams();
let id = null;
if (slugId) {
  const parts = slugId.split('-');
  const lastPart = parts[parts.length - 1];
  const parsedId = parseInt(lastPart, 10);

  if (!isNaN(parsedId) && parsedId > 0) {
    id = parsedId;
  }
}

// set Use of history for PUSH 
var navigate = useNavigate();

// Redirect to home is id is invalid
if (!id) {
    navigate("/noticias");
}
    
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
    

const [noticia, setNoticia] = React.useState(null);
const [loadingNoticia, setLoadingNoticia] = React.useState(true);
const [relacionadas, setRelacionadas] = React.useState([]);

const shareUrl = window.location.href;
const title = noticia?.title?.rendered ? noticia?.title?.rendered : 'Confira esta notícia da Estação do Olho!';
const description = noticia?.excerpt?.rendered ? noticia?.excerpt?.rendered : 'A Estação do Olho é uma startup de saúde ocular que conecta pacientes a clínicas de oftalmologia. Confira esta notícia!';

const categories = ['Todas', 'Na Mídia', 'Novidades', 'Tecnologia', 'Saúde', 'Social', 'Mercado', 'Eventos'];

//
React.useEffect(() => {
       
  // set scroll to top
  window.scrollTo(0, 1);

  setLoadingNoticia(false);

}, []); 

// Fetch news by ID
React.useEffect(() => {
    if (!id || isNaN(id)) return;
  
    setLoadingNoticia(true);
    fetch(`https://estacaodoolho.kindle.com.br/wp-json/wp/v2/posts/${id}?_embed`)
      .then(res => {
        if (!res.ok) {
          throw new Error(`Erro HTTP ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
        if (data && data.id) {
          setNoticia(data);
        } else {
          setNoticia(null);
        }
      })
      .catch(err => {
        console.error('Erro ao buscar notícia:', err);
        setNoticia(null);
        navigate("/noticias"); // Redirect to blogs home
      })
      .finally(() => {

        setTimeout(function() {
            setLoadingNoticia(false);
        },500);       

      });
  }, [id]);

// Fetch related news
React.useEffect(() => {
    if (!noticia || !noticia.categories?.length) return;
  
    const categoriaId = noticia.categories[0];
    const idAtual = noticia.id;
  
    fetch(`https://estacaodoolho.kindle.com.br/wp-json/wp/v2/posts?categories=${categoriaId}&exclude=${idAtual}&per_page=5&_embed`)
      .then(res => res.json())
      .then(data => {
        setRelacionadas(data);
      })
      .catch(err => {
        console.error('Erro ao buscar relacionadas:', err);
      });
  }, [noticia]);  


  // Set meta tags for SEO
  const metaTags = noticia ? (
    <Helmet>
      <title>{noticia.title?.rendered || 'Notícia'} | Blog Estação do Olho</title>
      <meta name="description" content={noticia.excerpt?.rendered?.replace(/<[^>]+>/g, '').trim() || 'Confira esta notícia em nosso blog'} />
      <meta name="keywords" content="blog, saúde ocular, oftalmologia, notícia" />
    </Helmet>
  ) : (
    <Helmet>
      <title>Notícia não encontrada | Blog Estação do Olho</title>
      <meta name="description" content="A notícia que você tentou acessar não foi encontrada." />
    </Helmet>
  );

  // Format date to Brazilian format
  const formatDate = (isoDate) => {
    const d = new Date(isoDate);
    return d.toLocaleDateString('pt-BR');
  };

  // Handle click on related news
  const handleClick = (post) => {
    if (!post || !post.id || !post.slug) return;
  
    setLoadingNoticia(true);

    window.scrollTo({ top: 0, behavior: 'smooth' });    

    const id = post.id;
    const slug = post.slug;
  
    navigate(`/noticias/${slug}-${id}`);
  };

  return (
    <>
    {metaTags}
 
    <div id="blogMainSection" className="wrapper_blog__content" >

        <HeaderView />

        <div className={isMobile ? "mobileWrapperBox wrapper_blog__content_container" : "wrapper_blog__content_container"}> 
        
            {/*<!-- Webdoor Header  -->*/}
            <div className="wrapper_blog__content_container_block" style={{marginTop:"1.5rem"}}>  

                <div className="wrapper_blog__content_container_block_webdoor">

                        {loadingNoticia &&
                            <Skeleton style={{flex:1,height:"500px",marginTop:"-7rem"}} />
                        }

                        {(!loadingNoticia) &&
                            <img src={noticia?._embedded?.['wp:featuredmedia']?.[0]?.source_url || webdoorNews1} className='noSelect' />
                        }
                    
                </div>

            </div>	


            {/*<!-- News Content  -->*/}
            <div className="wrapper_blog__content_container_block" style={{marginTop:"1rem"}}>  

                <div className="wrapper_blog__content_container_block_newsContent">

                        <div className="wrapper_shareTools">

                            {loadingNoticia && (
                                <>
                                <Skeleton className="shareIcon" style={{height:"80px", width:"48px"}} />
                                <Skeleton className="shareIcon" style={{height:"80px", width:"48px"}} />
                                <Skeleton style={{display:"flex",height:"80px", width:"48px"}} />
                                <Skeleton style={{display:"flex",height:"80px", width:"48px"}} />
                                </>
                            )}

                            <WhatsappShareButton className="shareIcon" url={shareUrl} title={title} description={description}>
                                <WhatsappIcon size={48} round />
                            </WhatsappShareButton>

                            <EmailShareButton className="shareIcon" url={shareUrl} subject={title} description={description} body="Dá uma olhada nessa notícia:">
                                <EmailIcon size={48} round />
                            </EmailShareButton>

                            <FacebookShareButton className="shareIcon" url={shareUrl} quote={title} description={description}>
                                <FacebookIcon size={48} round />
                            </FacebookShareButton>    

                            <LinkedinShareButton className="shareIcon" url={shareUrl} title={title} description={description}>
                            <LinkedinIcon size={48} round />
                            </LinkedinShareButton>

                            <TwitterShareButton className="shareIcon" url={shareUrl} title={title} description={description}>
                            <TwitterIcon size={48} round />
                            </TwitterShareButton>

                            <TelegramShareButton className="shareIcon" url={shareUrl} title={title} description={description}>
                            <TelegramIcon size={48} round />
                            </TelegramShareButton>

                            <ThreadsShareButton className="shareIcon" url={shareUrl} title={title} description={description}>
                            <ThreadsIcon size={48} round />
                            </ThreadsShareButton>                                                    

                            {/*<div className="shareIcon"><img src={iconWpp} className="noSelect" /></div>

                            <div className="shareIcon"><img src={iconEmail} className="noSelect" /></div>

                            <div className="shareIcon"><img src={iconSend} className="noSelect" /></div>*/}

                        </div>
                        
                        
                        <div className="wrapper_newContent">

                            {loadingNoticia && (
                                <>
                                <Skeleton  height="50px" />
                                <Skeleton  height="50px" />
                                <Skeleton  height="50px" />
                                <Skeleton  height="50px" />
                                </>
                            )}

                            {!loadingNoticia && (<>
                                <div className="category">{noticia?._embedded?.['wp:term']?.[0]?.[0]?.name || 'Sem categoria'}</div>

                                <div className="title">{noticia?.title?.rendered || 'Carregando...'}</div>

                                <div
                                className="summary"
                                dangerouslySetInnerHTML={{ __html: noticia?.excerpt?.rendered || 'Carregando...' }}
                                ></div>                            

                                <div
                                className="description"
                                dangerouslySetInnerHTML={{ __html: noticia?.content?.rendered || 'Carregando...' }}
                                ></div>
                             </>)}

                        </div>
                        
                        
                        <div className="wrapper_relatedNews">

                            <div className="title">Posts Relacionados</div>
                            
                            {loadingNoticia && (
                                <>
                                <Skeleton  height="50px" />
                                <Skeleton  height="50px" />
                                <Skeleton  height="50px" />
                                <Skeleton  height="50px" />
                                </>
                            )}

                            {!loadingNoticia &&
                            <>
                            {relacionadas.map(post => {
                                
                                const midia = post._embedded?.['wp:featuredmedia']?.[0];
                                const image = midia?.media_details?.sizes?.thumbnail?.source_url
                                            || midia?.media_details?.sizes?.medium?.source_url
                                            || midia?.source_url;	
                                
                            return (
                                <div key={post.id} className="relatedNewsCard applyPointer" onClick={()=>handleClick(post)}>
                                    <div className="relatedNewsContent">
                                    <div className="relatedNewsCategory row">
                                            <div className="categoryLabel">{post?._embedded?.['wp:term']?.[0]?.[0]?.name || 'Notícia'}</div>
                                            <div className="relatedNewsDate">{formatDate(post.date)}</div>                                        
                                    </div>
                                    <div className="relatedNewsTitle" dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
                                    </div>
                                    <div className="relatedNewsImage">
                                    <img src={image || fallbackImage} alt="Imagem da notícia" />
                                    </div>
                                </div>
                            )
                            
                            })}
                            </>
                            }
                            
                        </div>

                </div>

            </div>	



        </div>


    </div>
    </>
  );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  loginStatus:store.appReducer.loginStatus,
  currentCompanyStatus:store.appReducer.currentCompanyStatus,
  activationStatus:store.appReducer.activationStatus
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(BlogView);	


